import React from 'react';
import { Link, Typography, useTheme } from "@mui/material";
import NavBar from "../../components/navbar/navbar";
import { Container } from "../home/styles";
import { Grid, ListService, StyledBox } from "../services/styles";
import PlatformImage1 from "../../assets/svgs/Centro-de-ayuda.svg";
import PlatformImage2 from "../../assets/platform2.webp";
import PlatformImage3 from "../../assets/platform3.webp";
import PlatformImage4 from "../../assets/platform4.webp";
import PlatformImage5 from "../../assets/platform5.webp";
import PlatformImage6 from "../../assets/intranetcorpo.png";
import { verify } from '../../utils/common';
import { useNavigate } from 'react-router-dom';

const Platforms: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [navigate]);
    return (
        <Container>
            <NavBar active="plataformas" />
            <ListService theme={theme}>
                <StyledBox theme={theme}>
                    <img src={PlatformImage2} width="150px" alt="Centro de Ayuda RH" />
                    <Typography fontWeight="bold"></Typography>
                    <Link color="textPrimary" underline='none' fontWeight="bold" href="https://hcm17.sapsf.com/login?company=aryadebasa#/login" >
                        Success Factors
                    </Link>
                </StyledBox>
                <StyledBox theme={theme}>
                    <img src={PlatformImage3} width="150px" alt="Centro de Ayuda RH" />
                    <Link color="textPrimary" underline='none' fontWeight="bold" href="https://api.ssorh.mx/sandbox/v1/usuarios/auth/ssorh" >
                        SSORH
                    </Link>
                </StyledBox>
                <StyledBox theme={theme}>
                    <img src={PlatformImage1} width="110px" alt="Centro de Ayuda RH" />
                    <Typography fontWeight="bold"></Typography>
                    <Link color="textPrimary" underline='none' fontWeight="bold" href="https://recursoshumanosizzi.zendesk.com/hc/es-419" >
                        Centro de Ayuda RH
                    </Link>
                </StyledBox>
                <StyledBox theme={theme}>
                    <img src={PlatformImage5} width="150px" alt="Centro de Ayuda RH" />
                    <Link color="textPrimary" underline='none' fontWeight="bold" href="https://skyjira22.atlassian.net/helpcenter/RecursosHumanos/user/login?destination=" >
                        Jira
                    </Link>
                </StyledBox>
                <StyledBox theme={theme}>
                    <img src={PlatformImage6} width="130px" alt="Centro de Ayuda RH" />
                    <Link color="textPrimary" underline='none' fontWeight="bold" href="https://izzitelco.sharepoint.com/sites/intranetizzi?spStartSource=spappbar" >
                        Intranet
                    </Link>
                </StyledBox>
            </ListService>
        </Container>
    )
}

export default Platforms